import Vue from 'vue'
import VueRouter from 'vue-router'
import FormuleAptamil from '../views/FormuleAptamil.vue'
import Imunitate from '../views/Imunitate.vue'
import PreparareFormule from '../views/PreparareFormule.vue'
import SecreteleLaptelui from '../views/SecreteleLaptelui.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/formula-lapte-praf-aptamil',
        name: 'FormuleAptamil',
        meta: { index: 2 },
        props: { default: true },
        component: FormuleAptamil
    },
    {
        path: '/cum-construim-sistemul-imunitar',
        name: 'Imunitate',
        meta: { index: 1 },
        props: { default: true },
        component: Imunitate,
    },
    {
        path: '/preparare-si-tranzitie-aptamil',
        name: 'PreparareFormule',
        meta: { index: 3 },
        props: { default: true },
        component: PreparareFormule,
    },
    {
        path: '/secretele-laptelui-matern',
        name: 'SecreteleLaptelui',
        meta: { index: 0 },
        props: { default: true },
        component: SecreteleLaptelui,
    },

    {
        path: '*',
        name: 'Index',
        meta: { index: 0 },
        component: SecreteleLaptelui,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'development' ? '/dist' : '/totul-despre-imunitate',
    routes
})

export default router
